import React from 'react';
import UploadImage from '../components/upload-image';
import { Box } from '@mui/material';
interface IProps {
    name: string;
    maxFileSize: number;
}
const QuestionImage: React.FC<IProps> = ({ name, maxFileSize }) => {
    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: ['center', 'flex-start'],
                flexDirection: 'column',
                alignItems: ['center', 'flex-start'],
            }}
        >
            <UploadImage name={name} maxFileSize={maxFileSize} />
        </Box>
    );
};

export default QuestionImage;
